import { createRouter, createWebHashHistory  } from 'vue-router';
import LoginPage from '@/pages/LoginPage.vue';
import DataDisplayPage from '@/pages/DataDisplayPage.vue';  // 假设数据页已创建
import AdminPage from '@/pages/AdminPage.vue'; 
import PhoneVerify from '@/pages/PhoneVerify.vue' // 导入验证码页面
import AncAdminAnchorhor from '@/pages/AnchorAdmin.vue' // 导入验证码页面
const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginPage },
  { 
    path: '/data', 
    component: DataDisplayPage, 
    meta: { requiresAuth: true }  // 标记需要登录
  },
  { 
    path: '/Admin', 
    component: AdminPage, 
    meta: { 
      requiresAuth: true // 需要登录
  
    }  
  },
  { 
    path: '/AdminAnchor', 
    component: AncAdminAnchorhor, 
    meta: { 
      requiresAuth: true // 需要登录
  
    }  
  },
  {
    path: '/phone-verify', // 验证码页面路由
    name: 'PhoneVerify',
    component: PhoneVerify
  },
  
  
  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
  history: createWebHashHistory (process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router;